import React, { useRef, useState } from 'react';


const OTPInput = ({ length = 6, onChange }) => {


  const inputRef = useRef(Array(length).fill(null));

  const [OTP, setOTP] = useState(Array(length).fill(''));

  const handleTextChange = (input, index) => {
    const newPin = [...OTP];
    newPin[index] = input;
    setOTP(newPin);


    if (input.length === 1 && index < length - 1) {
      inputRef.current[index + 1]?.focus();
    }


    if (input.length === 0 && index > 0) {
      inputRef.current[index - 1]?.focus();
    }

    if (newPin.every((digit) => digit !== '')) {
      onComplete(newPin.join(''));
    }
      console.log(newPin.join(''));
      onChange(newPin.join(''))
  };

  const onComplete = (e) => {
    console.log(e)
    // onChange(e)
  }

  console.log(OTP)

  return (
    <div className={`flex gap-x-2 items-center flex-row-reverse w-full justify-center`}>
      {Array.from({ length }, (_, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          value={OTP[index]}
          onChange={(e) => handleTextChange(e.target.value, index)}
          ref={(ref) => (inputRef.current[index] = ref)}
          className={`w-10 h-10 sm:w-14 sm:h-14 text-center outline-none rounded-md border border-gray-200 text-md bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700`}
          style={{ marginRight: index === length - 1 ? '0' : '10px' }}
        />
      ))}
    </div>
  );
};


export default OTPInput;